import {
  addPlacementToList,
  addPlacementToListFailure,
  addPlacementToListSuccess,
  deletePlacement,
  deletePlacementFailure,
  deletePlacementSuccess,
  editPlacement,
  editPlacementFailure,
  editPlacementSuccess,
  getNightPlacementList,
  setNightPlacementList
} from "../actions/nightPlacementListAction";
import { handleActions } from "redux-actions";

const initState = {
  placements: {
    data: []
  },
  tableLoading: false,
  buttonLoading: false,
  errorMessage: null,
  updated: false
};

const nightPlacementListReducer = handleActions(
  {
    [getNightPlacementList]: state => {
      return { ...state, tableLoading: true };
    },
    [setNightPlacementList]: (state, { payload: { placements } }) => {
      return { ...state, placements: placements, tableLoading: false, updated: false };
    },
    [addPlacementToList]: (state, action) => {
      return { ...state, buttonLoading: true };
    },
    [addPlacementToListSuccess]: (state, action) => {
      return {
        ...state,
        buttonLoading: false
      };
    },
    [addPlacementToListFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, buttonLoading: false };
    },
    [deletePlacement]: state => {
      return { ...state, tableLoading: true };
    },
    [deletePlacementSuccess]: state => {
      return { ...state, tableLoading: false };
    },
    [deletePlacementFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, tableLoading: false };
    },
    [editPlacement]: state => {
      return { ...state, tableLoading: true };
    },
    [editPlacementSuccess]: state => {
      return { ...state, tableLoading: false, updated: true};
    },
    [editPlacementFailure]: (state, { payload: { message, errors } }) => {
      return { ...state, errorMessage: message, errors, tableLoading: false };
    }
  },
  initState
);

export default nightPlacementListReducer;
